export default {
    'FormularioFlujo.GuardarFlujo': 'Create Flow',
    'FormularioFlujo.EditarFlujo': 'Edit Flow',
    'FormularioFlujo.flujoDescripcion': 'Description',
    'FormularioFlujo.Estado': 'State',
    'FormularioFlujo.Guardar': 'Save',
    'FormularioFlujo.Editar': 'Edit',
};
